---
de:
  market_prices:
    average: Durchschnittspreis
    avg_power_prices_year: Durchschnittliche Strompreise {year} [{currency_code}/MWh]
    heading: Marktpreise
    power_prices_year: Strompreise {year}
    price_factor: Preisfaktor [%]
    realized_price: Realisierter Preis
    reservoir_fill:
      heading: Kapazität des norwegischen Wasserkraftspeichers
      y_axis_title: Füllgrad in Prozent
